<template>
  <span>
    <slot
      :onClick="onClick"
      :disabled="submit"
    />
    <modal-reassign
      :show.sync="show"
      :disabled="submit"
      :phone-numbers="[room.phone_number]"
      @select="select"
    />
  </span>
</template>

<script>
import catchDispatch from '../../../utils/catchDispatch';
import ModalReassign from './Reassign/ModalReassignHeaderRoomComponents';

export default {
  name: 'ReassignBox',
  components: {
    ModalReassign,
  },
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tForm: 'room.header.reassign',
      show: false,
      submit: false,
    };
  },
  methods: {
    onClick() {
      this.show = true
    },
    select(user_id) {
      const chat_id = this.room.id;

      this.submit = true;
      this.$store.dispatch('rooms/assign', {chat_id, user_id})
        .then(() => this.show = false)
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.submit = false);
    },
  },
}
</script>

<style scoped>

</style>
